export const CATEGORY_SLIDER_HOME_WEB = 'category.slider.home.web';
export const CATEGORY_RECOMENDED_ITEMS_HOME_WEB = 'category.recomended.items.home.web';
